import { IPickingRouteSearch } from '../../../interfaces/PickingRoute/PickingRoute'
import {
  configDateInitial,
  setToFinalDateTime,
  setToInitialDateTime
} from '../../../utils/dateHelper'
import { actionTypes } from '../types/actionTypes'
import { ReducerPickingAdminState } from '../types/reducerTypes'

export const busquedaInitialState: IPickingRouteSearch = {
  pickingRouteId: 0,
  workOrderId: 0,
  positionId: 0,
  pickerId: 0,
  initialDate: configDateInitial(7),
  endDate: configDateInitial(0),
  zoneId: 0,
  subzoneId: 0,
  pickingRouteStateId: 0,
  validationStatusId: 0,
  skuId: '',
  warehouseId: 0,
  isIncomplete: '',
  typePickingRouteId: 0
}

export const reducerInitialState: ReducerPickingAdminState = {
  page: 0,
  rowsPerPage: 5,
  totalItems: 0,
  rows: [],
  busqueda: busquedaInitialState,
  filters: [
    {
      key: 'initialDate',
      value: setToInitialDateTime(busquedaInitialState.initialDate)
    },
    { key: 'endDate', value: setToFinalDateTime(busquedaInitialState.endDate) }
  ],
  isLoading: false,
  checkboxArray: [],
  openSnackbar: false,
  messageColor: '',
  messageStatus: '',
  subZones: [],
  users: [],
  sorters: [],
  firstEffect: true,
  isOpenDelete: false,
  enabledList: false,
  zonesByWarehouse: [],
  values: [],
  pickingRoutesWithoutStock: 0
}

export const pickingRouteAdminReducer = (
  state: ReducerPickingAdminState,
  action: actionTypes
) => {
  switch (action.type) {
    case 'CHANGE_PAGE':
      return {
        ...state,
        page: action.payload
      }
    case 'CHANGE_PAGE_SIZE':
      return {
        ...state,
        rowsPerPage: action.payload
      }
    case 'SET_TOTAL_ITEMS':
      return {
        ...state,
        totalItems: action.payload
      }
    case 'SET_ROWS':
      return {
        ...state,
        rows: action.payload
      }
    case 'SET_BUSQUEDA': {
      return {
        ...state,
        busqueda: action.payload
      }
    }
    case 'SET_FILTERS': {
      const { value: initialDateValue } = action.payload.filter(
        (item) => item.key === 'initialDate'
      )[0]
      const { value: endDateValue } = action.payload.filter(
        (item) => item.key === 'endDate'
      )[0]

      // transformar initailDateValue y endDateValue

      const initialDateFormated = new Date(
        `${initialDateValue} 00:00:00`
      ).toISOString()

      const endDateFormated = new Date(`${endDateValue} 23:59:59`).toISOString()

      // filtrar payload
      const filteredPayload = action.payload.filter(
        (item) => item.key !== 'initialDate' && item.key !== 'endDate'
      )

      return {
        ...state,
        page: 0,
        filters: [
          ...filteredPayload,
          { key: 'initialDate', value: initialDateFormated },
          { key: 'endDate', value: endDateFormated }
        ]
      }
    }
    case 'SET_IS_LOADING': {
      return {
        ...state,
        isLoading: action.payload
      }
    }

    case 'ADD_CHECKBOX_ARRAY': {
      return {
        ...state,
        checkboxArray: action.payload
      }
    }
    case 'SWITCH_SNACKBAR':
      return {
        ...state,
        openSnackbar: action.payload
      }
    case 'SET_MESSAGE_COLOR':
      return {
        ...state,
        messageColor: action.payload
      }
    case 'SET_MESSAGE_STATUS':
      return {
        ...state,
        messageStatus: action.payload
      }

    case 'SET_SUBZONES':
      return {
        ...state,
        subZones: action.payload
      }

    case 'SET_USERS':
      return {
        ...state,
        users: action.payload
      }

    case 'SET_SORTERS':
      return {
        ...state,
        sorters: action.payload
      }

    case 'SET_FIRST_EFFECT':
      return {
        ...state,
        firstEffect: action.payload
      }

    case 'SET_ENABLED_LIST':
      return {
        ...state,
        enabledList: action.payload
      }

    case 'SET_ZONES_BY_WAREHOUSE':
      return {
        ...state,
        zonesByWarehouse: action.payload
      }

    case 'SET_OPEN_DELETE':
      return {
        ...state,
        isOpenDelete: action.payload
      }

    case 'SET_VALUES':
      return {
        ...state,
        values: action.payload
      }

    case 'SET_PICKINGROUTES_WITHOUT_STOCK':
      return {
        ...state,
        pickingRoutesWithoutStock: action.payload
      }

    default:
      return state
  }
}
